<template>
  <div>
    <div class="left-aside">
      <div class="registration-form">
        <div class="brand">
          <router-link to="/Login"><img :src="require('@/assets/img/logo-management.svg')" alt=""></router-link>
        </div>
        <div class="hero-txt forgot">
          <h2>Forgot Password</h2>
          <span>Enter your email to reset your password.</span>
        </div>
        <form class="form-signin" @submit="sub">
          <div v-if="errorMessage">
            <div class="error-message">
              <!-- <img src="https://halcyon-api-files.s3-ap-southeast-1.amazonaws.com/cloud-assets/icon-error-mismatch.svg"> -->
              {{ errorMessage }}
            </div>
          </div>
          <div v-if="sendSuccessMessage">
            <div class="primary-message alert alert-primary">{{ sendSuccessMessage }}</div>
          </div>

          <div class="form-label-group">
            <label for="inputEmail">Email Address</label>
            <input type="text" id="inputEmail" class="form-control has-error" placeholder="Email Address" autofocus v-model="user.email" :disabled="step == 2 ? true : false">
          </div>
          <div class="form-label-group form-verify" v-if="step == 2">
            <label for="inputPassword">Verification Code</label>
            <input type="text" id="inputPassword" class="form-control" v-to-uppercase maxlength="6" v-model="user.code">
          </div>
          <button class="btn btn-lg btn-primary btn-block btn-submit" type="submit" :disabled="isSubmitDisabled">Submit</button>
          <a v-if="step == 2" href="javascript:void(0)" class="btn btn-lg btn-default btn-block btn-forgot-pass mb-3" @click="backButton">Back</a>
          <div class="txt-center">
            <span v-if="step == 2">Didn't receive a code? <a href="javascript:void(0)" @click="sendEmailVerification(true)">Send a new one.</a></span><br>
            <span class="txt-center">Don't have an account? <a href="#/Registration" class="">Register</a></span>
            <span class="txt-center"> or go back to <a href="#/Login" class="">Login</a></span>
          </div>
        </form>
      </div>
    </div>
    <div class="right-aside"><img :src="assets + 'register-gfx.jpg'" alt=""></div>
  </div>
</template>
<script>
import { post } from '@/utils/http';
import { isEmail } from '@/utils/data-dictionary';

export default {
  name: 'ForgotPassword',
  data() {
    return {
      assets: process.env.VUE_APP_ASSETS,
      errorMessage: "",
      sendSuccessMessage: "",
      isSubmitDisabled: false,
      user: {
        email: null,
        code: null
      },
      step: 1
    }
  },
  methods: {
    sub: function (event) {
      event.preventDefault();
      this.errorMessage = "";
      this.sendSuccessMessage = "";

      if (this.step == 1) {
        if (isEmail(this.user.email)) {
          this.isSubmitDisabled = true;
          this.sendEmailVerification(false);
        } else {
          this.errorMessage = "Please enter valid email format.";
        }
      } else {
        this.validateVerficationCode();
      }
    },
    sendEmailVerification(isClickVerification) {
      var params = {
        email: this.user.email,
        main: true
      };
      post("/Api/User/CheckEmail", params, (response) => {
        if (response.data.isExist) {
          this.sendVerficationCode(isClickVerification);
        } else {
          this.errorMessage = "Email does not exist.";
          this.isSubmitDisabled = false;
        }
      })
    },
    sendVerficationCode(sendVerficationCode) {
      post('/Api/Generate/Code', { type: "ForgotPassword", email: this.user.email }, (response) => {
        this.isSubmitDisabled = false;
        if (response.data && response.data.status == 'ERROR') {
          this.errorMessage = response.data.message;
        } else {
          if (sendVerficationCode == true) {
            this.errorMessage = "";
            this.sendSuccessMessage = 'Verification Code has been sent. Please check your email and enter the correct code.';
          }
          this.step = 2;
        }
      })
    },
    validateVerficationCode() {
      if (this.user.code === null || this.user.code == "") {
        this.errorMessage = "Please enter verification code.";
      } else if (this.user.code.length < 6) {
        this.errorMessage = "Invalid code entered. Please check your email and re-enter the correct code.";
      } else {
        post('/Api/Verify/Code', { type: "ForgotPassword", email: this.user.email, code: this.user.code }, (response) => {
          if (response.data.status == "OK") {
            this.$store.commit('FORGOT_PASSWORD', { code: this.user.code, email: this.user.email });
            this.$router.push("/ResetPassword");
          } else {
            this.errorMessage = response.data.message;
          }
        })
      }
    },
    backButton() {
      this.step--;
      this.errorMessage = "";
      this.user.code = "";
    }
  }
}
</script>